import { render, staticRenderFns } from "./CameraChildError.vue?vue&type=template&id=0c9974e2&scoped=true&"
import script from "./CameraChildError.vue?vue&type=script&lang=ts&"
export * from "./CameraChildError.vue?vue&type=script&lang=ts&"
import style0 from "./CameraChildError.vue?vue&type=style&index=0&id=0c9974e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9974e2",
  null
  
)

export default component.exports